import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useCartStore } from '@/store/cartStore';
import { cn } from '@/lib/currencyFormatter';
import { useTranslation } from 'react-i18next';

interface FloatingCartButtonProps {
  onClick: () => void;
  className?: string;
}

export const FloatingCartButton = React.memo<FloatingCartButtonProps>(({
  onClick,
  className,
}) => {
  const { getTotalItems } = useCartStore();
  const { t } = useTranslation();
  const totalItems = getTotalItems();

  if (totalItems === 0) {
    return null;
  }

  return (
    <Button
      onClick={onClick}
      size="lg"
      className={cn(
        "fixed bottom-20 right-6 h-14 w-14 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 z-60 md:bottom-24 md:right-8",
        className
      )}
    >
      <div className="relative">
        <ShoppingCart className="h-6 w-6" />
        {totalItems > 0 && (
          <span className="absolute -top-4 -right-4 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-medium">
            {totalItems > 99 ? '99+' : totalItems}
          </span>
        )}
      </div>
      <span className="sr-only">{t('waiterOrdering.viewCart')} ({totalItems} items)</span>
    </Button>
  );
});

FloatingCartButton.displayName = 'FloatingCartButton'; 